module.exports = __webpack_public_path__ + "img/sam-rodriquez-untitled-2.15cf626.jpg";